export const shadows = {
   sh1 : "0 2px 8px rgba(0, 0, 0, 0.1)"
  };